import { render, staticRenderFns } from "./login-score.vue?vue&type=template&id=ac7cc89c&scoped=true&"
import script from "./login-score.vue?vue&type=script&lang=js&"
export * from "./login-score.vue?vue&type=script&lang=js&"
import style0 from "./login-score.vue?vue&type=style&index=0&id=ac7cc89c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7cc89c",
  null
  
)

export default component.exports